import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom'
import {AuthUserProvider} from "./providers/AuthProvider";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import {LangProvider} from "./providers/LangProvider";
// import { indigo } from '@mui/material/colors';
// import theme from './theme'
const theme = createTheme({
  palette: {
    primary: {
      main: '#204488',
    },
    secondary: {
      main: '#878787',
    },
    success:{
      main: '#7DF0C0',
    },
    background: {
      default: '#FBFBFB'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root:{
          borderRadius: 30,
        },
        sizeLarge: {
          fontSize: 18
        },
        sizeMedium: {
          fontSize: 16,
          textTransform: 'uppercase'
        },
        sizeSmall: {
          fontSize: 14
        },
        textSizeMedium: {
          fontSize: 16,
          textTransform: 'capitalize'

        },
        textSecondary:{
          color: '#414141'
        }

      }
    },
    MuiPaper: {
      styleOverrides: {
        rounded:{
          borderRadius: 10
        }
      }
    }},
  shape: {borderRadius: 0},
  typography: {
    body2: {
      fontSize: 14,
    },
    body1: {
      fontSize: 18,
    },
    h6:{
      fontSize: 24
    },
    fontFamily: [
     'Raleway', 'sans-serif'
    ].join(','),
    button: {
      textTransform: "capitalize"
    }
  }
})
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <LangProvider>
    <AuthUserProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
          <Router>
            <App />
          </Router>
      </ThemeProvider>
    </AuthUserProvider>
  </LangProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
